import "@apk-games/runtime/compat/legacy-webview";
import { configureGameRuntime, getConfiguredGameRuntime } from "@apk-games/runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing #root element");
}

const root = ReactDOM.createRoot(rootElement);

function BootFailure({ error }: { error: unknown }) {
  return (
    <div className="boot-screen boot-error" role="alert">
      <strong>掌中日常暂时没有成功启动</strong>
      <p>{error instanceof Error ? error.message : "发生了未知启动错误"}</p>
      <button type="button" onClick={() => window.location.reload()}>重新加载</button>
    </div>
  );
}

class GameErrorBoundary extends React.Component<React.PropsWithChildren, { error?: unknown }> {
  state: { error?: unknown } = {};

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: unknown) {
    console.error("Pocket phone render failed", error);
  }

  render() {
    if (this.state.error) return <BootFailure error={this.state.error} />;
    return this.props.children;
  }
}

async function bootstrap() {
  try {
    const gameConfig = getConfiguredGameRuntime(1006);
    configureGameRuntime({ packageId: gameConfig.packageId, appId: "pocket-phone" });

    // 游戏模块会间接加载存档、会话和 Pixi 舞台。先完成 runtime 配置，
    // 避免模块求值阶段读取到 packageId=0 而让 React 根节点保持空白。
    const { GameApp } = await import("./features/game/components/GameApp");
    root.render(<React.StrictMode><GameErrorBoundary><GameApp /></GameErrorBoundary></React.StrictMode>);
  } catch (error) {
    console.error("Failed to bootstrap pocket phone", error);
    root.render(<BootFailure error={error} />);
  }
}

void bootstrap();
